import React, { useMemo } from 'react';

// store
import { useStoreValue } from '../../../../../../../../store';
import { armExternalDrag } from '../../../../../../../../store/externalDragStore';

// hooks
import useSelection from '../../../../../../../../hooks/useSelection';
import useCueItemMenu from '../../../../../../../../hooks/useCueItemMenu';
import { SELECTION_KINDS } from '../../../../../../../../helpers/selection';

// tools
import getDateFromISOstring from '../../../../../../../../helpers/getDateFromISOstring';

// components
import TripleDotsIcon from '../../../../../../../../icons/TripleDotsIcon';
import ButtonIconSimple from '../../../../../../../../components/ButtonWrapper/components/ButtonIconSimple';
import LikeIcon from '../../../../../../../../icons/LikeIcon';
import ToReviewIcon from '../../../../../../../../icons/ToReviewIcon';
import DislikeIcon from '../../../../../../../../icons/DislikeIcon';
import Mix2Icon from '../../../../../../../../icons/Mix2Icon';
import ButtonIconContextMenu from '../../../../../../../../components/ButtonWrapper/components/ButtonIconContextMenu';

const ListOfMixItems = () => {
    const cueSheet = useStoreValue('cueSheet');
    const mixItems = useMemo(() => {
        return cueSheet.filter(o => o.cueType === 'MIX' && o.clip)
    }, [cueSheet]);

    const orderedIds = useMemo(() => mixItems.map(item => item.id), [mixItems]);
    const { isSelected, select } = useSelection(SELECTION_KINDS.CUE, orderedIds);
    const menuItemsFor = useCueItemMenu();

    return(
        mixItems.map(item => <li key={`mix_${item.id}`}
            className={`auxListItem${isSelected(item.id) ? ' auxListItem--selected' : ''}`}
            aria-selected={isSelected(item.id)}
            style={{ cursor: 'grab' }}
            onMouseDown={(e) => {
                if (e.button !== 0) return;
                e.preventDefault();
                // The drag only starts once the pointer moves, so a plain press
                // stays a click and selects the item instead.
                armExternalDrag(item, e);
            }}
            onClick={(e) => {
                if (e.target.closest('button, a, input, dialog')) return;
                select(item.id, e);
            }}
        >
            <div className="icon">
                <Mix2Icon/>
            </div>
            <div className="title">
                <h3>{item.title}</h3>
                <span>{item.timecode}</span>
            </div>
            <div className="rating lastGroup">
                <ButtonIconSimple>
                    <LikeIcon/>
                </ButtonIconSimple>
                <ButtonIconSimple>
                    <ToReviewIcon/>
                </ButtonIconSimple>
                <ButtonIconSimple>
                    <DislikeIcon/>
                </ButtonIconSimple>
            </div>
            <div className="meta">
                        <span>{getDateFromISOstring(item.date, {
                            day: '2-digit',
                            month: 'short'
                        })}</span>
                <ButtonIconContextMenu menuItems={menuItemsFor(item)}>
                    <TripleDotsIcon/>
                </ButtonIconContextMenu>
            </div>
        </li>)
    )
}

export default ListOfMixItems;